import { gql } from '@apollo/client';

const query = gql`
  query reviewAggregates(
    $listingId: String
    $categoryId: String
    $suburbName: String
    $state: String
  ) {
    reviewAggregates(
      listingId: $listingId
      categoryId: $categoryId
      suburbName: $suburbName
      state: $state
    ) {
      averageRating
      count
    }
  }
`;

module.exports = query;
